import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import ReactTable from 'react-table';
import { epochToDate, epochToTime } from 'utils';
import { Separator } from '@cuemath/comps';
import Pagination from 'modules/list/pagination';

import styled from 'styled-components';
import PropTypes from 'prop-types';
import { openModal } from 'actions/modal';
import { IconButton } from 'modules/list';
import EditIcon from 'img/edit.png';
import { Row } from '@cuemath/comps';
import { MODAL_FORM } from 'constants/form';
import { FULL_DATE } from 'constants/date';
import { get as getStudentCourseLog } from 'actions/student-course-log';

const TableWrapper = styled.div`
  width: 100%;
  text-align: center;
  overflow-x: auto;
  margin: 20px 0;
  padding-left: 10px;
  padding-right: 10px;
`;
const RESULTS_PER_PAGE = 6;

const getCourseLogFromStore = (props, state) => {
  const { studentCourseId, studentCourseLog } = props;
  const { page, isCountRequired } = state;
  const query = {
    page,
    per_page: RESULTS_PER_PAGE,
    ...(isCountRequired && { include_count: true }),
  };

  const studentCourseLogGet = store.get(studentCourseLog, studentCourseId, query);
  const { isLoaded, data } = studentCourseLogGet || {};

  if (studentCourseLogGet && isLoaded) {
    const { logs: courseLog, logs_size: logSize } = data || {};
    return {
      courseData: courseLog,
      ...(logSize && { courseLogSize: logSize }),
    };
  }

  return {};
};

class StudentCourseLogModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isCountRequired: true,
      courseData: [],
      page: 1,
      courseLogSize: 0,
    };
  }

  static propTypes = {
    actions: PropTypes.shape({
      openModal: PropTypes.func.isRequired,
      getStudentCourseLog: PropTypes.func.isRequired,
    }),
    studentCourseId: PropTypes.string.isRequired,
    studentCourseLog: PropTypes.shape({}).isRequired,
  };

  static getDerivedStateFromProps(props, state) {
    return getCourseLogFromStore(props, state);
  }

  getCourseLog = () => {
    const { actions, studentCourseId } = this.props;
    const { page } = this.state;
    const query = { page, per_page: RESULTS_PER_PAGE };

    actions.getStudentCourseLog(studentCourseId, query);
  };

  componentDidMount() {
    const { actions, studentCourseId } = this.props;
    const { page, isCountRequired } = this.state;
    const query = { page, per_page: RESULTS_PER_PAGE, include_count: isCountRequired };

    actions.getStudentCourseLog(studentCourseId, query);
  }

  onPageChange = newPage => {
    this.setState({ page: newPage, isCountRequired: false }, this.getCourseLog);
  };

  openCourseClassLogActionsForm = (logId, classTakenOn, classType) => {
    const { actions, studentId } = this.props;

    actions.openModal(
      MODAL_FORM.COURSE_CLASS_LOG_ACTION_MODAL,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 50) / 100)}px`,
        height: 'fit-content',
      },
      {
        classLogData: {
          logId,
          classDate: epochToDate(classTakenOn, FULL_DATE),
          classTime: epochToTime(classTakenOn),
          classType,
        },
        studentId,
      },
    );
  };

  render() {
    const { page, courseData, courseLogSize } = this.state;

    let columnsData = [
      {
        Header: 'Date',
        accessor: 'class_taken_on',
        Cell: ({ value }) => (value ? epochToDate(value, FULL_DATE) : ''),
      },
      {
        Header: 'Class Time',
        accessor: 'class_taken_on',
        Cell: ({ value }) => (value ? epochToTime(value) : ''),
      },
      {
        Header: 'Type',
        accessor: 'class_type',
      },
      {
        Header: 'Status',
        accessor: 'class_start_date',
        Cell: row => {
          const {
            class_lapsed: isLapsed,
            student_no_show: noShow,
            class_lapse_reverted: classLapseReverted,
          } = (row && row.original) || {};
          if (classLapseReverted) {
            return 'No show reverted';
          }
          const isNotLapsed = noShow ? 'No Penalty' : 'Class Attended';
          if (isLapsed) {
            return 'No show';
          }
          return isNotLapsed;
        },
      },
      {
        Header: 'Action',
        accessor: 'is_invalid',
        Cell: row => {
          const {
            is_invalid: isInvalid,
            id: logId,
            class_taken_on: classTakenOn,
            class_type: classType,
            class_lapsed: isLapsed,
            class_lapse_reverted: classLapseReverted,
          } = (row && row.original) || {};
          if (!isInvalid && isLapsed && !classLapseReverted) {
            return (
              <Row justifyContent="space-around">
                <IconButton
                  icon={EditIcon}
                  onClick={() =>
                    this.openCourseClassLogActionsForm(logId, classTakenOn, classType)
                  }
                />
              </Row>
            );
          }
          return '-';
        },
      },
    ];

    const tableColumns = [
      {
        Header: ``,
        columns: columnsData,
      },
    ];

    return (
      <TableWrapper>
        <h3>Course Class Log</h3>
        <ReactTable
          data={courseData}
          className="-striped -highlight"
          columns={tableColumns}
          defaultPageSize={RESULTS_PER_PAGE}
          style={{ maxHeight: 300, textAlign: 'center' }}
        />
        {Boolean(courseLogSize) && (
          <>
            <Separator transparent height="10" />
            <Pagination
              page={page}
              perPage={RESULTS_PER_PAGE}
              count={courseLogSize}
              onPageChange={this.onPageChange}
            />
          </>
        )}
      </TableWrapper>
    );
  }
}
export default connect(
  ({ studentCourseLog }) => ({
    studentCourseLog,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        openModal,
        getStudentCourseLog,
      },
      dispatch,
    ),
  }),
)(StudentCourseLogModal);
